import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => (
  <div style={{ maxWidth: '720px', margin: '0 auto', padding: '40px 20px 80px' }}>
    <Link to="/teams" style={{ color: '#F97316', fontSize: '13px', textDecoration: 'none', display: 'inline-block', marginBottom: '32px' }}>
      ← Back
    </Link>

    <h1 style={{ fontSize: '28px', fontWeight: 900, marginBottom: '6px' }}>Privacy Policy</h1>
    <p style={{ color: '#4A5568', fontSize: '13px', marginBottom: '40px' }}>Last updated: March 2026</p>

    <Section title="1. Overview">
      Slow Rib Sports Streaming ("we", "us", or "our") operates slowrib.com. This Privacy Policy explains how we collect,
      use, and protect your information when you use our Service.
    </Section>

    <Section title="2. Information We Collect">
      When you create an account, we collect:
      <ul style={{ marginTop: '10px', paddingLeft: '20px', lineHeight: 2 }}>
        <li>Username</li>
        <li>Email address</li>
        <li>Password (stored as a secure hash — we never store your plain-text password)</li>
      </ul>
      We do not collect payment information, phone numbers, or any sensitive personal data beyond the above.
    </Section>

    <Section title="3. How We Use Your Information">
      Your information is used solely to:
      <ul style={{ marginTop: '10px', paddingLeft: '20px', lineHeight: 2 }}>
        <li>Authenticate you and maintain your account session</li>
        <li>Display your username within the app</li>
        <li>Send service-related notifications if applicable</li>
      </ul>
      We do not sell, rent, or share your personal information with third parties for marketing purposes.
    </Section>

    <Section title="4. Authentication & Session Storage">
      We use JSON Web Tokens (JWT) stored in your browser's local storage to keep you signed in.
      This token expires after 7 days. You can sign out at any time to remove it from your device.
    </Section>

    <Section title="5. Video Content">
      Video streams and recordings are hosted privately on our servers. Access is restricted to authenticated users only.
      We do not share or sell video content.
    </Section>

    <Section title="6. Data Security">
      We take reasonable measures to protect your data, including encrypted passwords and HTTPS-only access.
      However, no method of transmission over the internet is 100% secure.
    </Section>

    <Section title="7. Children's Privacy">
      This Service is intended for use by parents, coaches, and team administrators.
      We do not knowingly collect personal information directly from children under 13.
      Player profiles (names, numbers, photos) are created and managed by authorized adult administrators only.
    </Section>

    <Section title="8. Changes to This Policy">
      We may update this Privacy Policy from time to time. We will post the updated policy on this page with a revised date.
      Continued use of the Service after changes constitutes acceptance of the updated policy.
    </Section>

    <Section title="9. Contact">
      If you have questions about this Privacy Policy or how your data is handled, please contact us at{' '}
      <a href="mailto:admin@slowrib.com" style={{ color: '#F97316', textDecoration: 'none' }}>admin@slowrib.com</a>.
    </Section>
  </div>
);

const Section = ({ title, children }: { title: string; children: React.ReactNode }) => (
  <div style={{ marginBottom: '32px' }}>
    <h2 style={{ fontSize: '16px', fontWeight: 800, marginBottom: '10px', color: '#F0F6FC' }}>{title}</h2>
    <div style={{ fontSize: '14px', lineHeight: 1.8, color: '#8892A4' }}>{children}</div>
  </div>
);

export default Privacy;
